"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundTickIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("./withSVGIcon");
var themes_1 = require("../../themes");
var Icon = function (_a) {
    var _b = _a.stroke, stroke = _b === void 0 ? themes_1.THEME.colors.basic.Black : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? 1 : _c;
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx("path", { d: "M1 4.18182L4.75 8L11 1", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }, void 0) }, void 0));
};
exports.RoundTickIcon = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 12 9' });
//# sourceMappingURL=RoundTickIcon.js.map